import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as actions from "redux/actions/NotebookActions";
import * as commonService from "utility/CommonService.js";
import { useRouteMatch } from 'react-router-dom'
import NotebookDetailsPage from "components/NoteBooks/NotebookPreview";

export const NotebookPreview = ({ history, notebook }) => {
  const dispatch = useDispatch();
  const { iframe } = useSelector((state) => state.notebookReducer);
  const [localURL, setURL] = useState("");
  const [loaded, setLoaded] = useState(false);
  const match = useRouteMatch('/notebooks/:id/preview');
  const id = match.params.id;

  //effect for get project
  useEffect(() => {
    if (!loaded) {
      setLoaded(true);
      dispatch(actions.previewNotebook({ id })).then((res) => {
        if (res.value.success) {
          console.log("open success");
          commonService.isLoading.onNext(true);
          setTimeout((e) => {
            setURL(res.value.iframe);
            commonService.isLoading.onNext(false);
          }, 5000);
        }
      });
    }
  }, [notebook, dispatch, history, iframe, id, loaded]);

  return (
    <NotebookDetailsPage
      history={history}
      notebook={notebook}
      iframe={iframe}
      localURL={localURL}
    />
  );
};

export default NotebookPreview;
